var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnooBoxPickedUpActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "34px",
    viewBox: "0 0 58 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "path-1",
    points: "0.144941176 8.07421053 30.3509519 10.9239947 30.7646631 2.92777895 0.558502674 0.0779947368"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-3",
    points: "0.144941176 8.07421053 30.3509519 10.9239947 30.7646631 2.92777895 0.558502674 0.0779947368"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-5",
    points: "0.144941176 8.07421053 30.3509519 10.9239947 30.7646631 2.92777895 0.558502674 0.0779947368"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-7",
    points: "0.144941176 8.07421053 30.3509519 10.9239947 30.7646631 2.92777895 0.558502674 0.0779947368"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-9",
    points: "0.144941176 8.07421053 30.3509519 10.9239947 30.7646631 2.92777895 0.558502674 0.0779947368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00414113434,4.65337762 C0.00414113434,7.2224277 2.0849369,9.30501448 4.6517362,9.30501448 L4.6517362,9.30501448 C7.21853549,9.30501448 9.29937267,7.2224277 9.29937267,4.65337762 L9.29937267,4.65337762 C9.29937267,2.08441045 7.21853549,0.00182366745 4.6517362,0.00182366745 L4.6517362,0.00182366745 C2.0849369,0.00182366745 0.00414113434,2.08441045 0.00414113434,4.65337762 L0.00414113434,4.65337762 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00451383643,3.90733185 C0.00451383643,6.47625758 2.08522678,8.55876147 4.65198467,8.55876147 L4.65198467,8.55876147 C6.27506086,8.55876147 7.70188869,7.72472374 8.53313859,6.46282876 L8.53313859,6.46282876 C7.79999217,6.94647365 6.92335544,7.22980526 5.97979798,7.22980526 L5.97979798,7.22980526 C3.41312292,7.22980526 1.33232715,5.14725993 1.33232715,2.57837564 L1.33232715,2.57837564 C1.33232715,1.63392314 1.6154565,0.756531862 2.09864406,0.0228787371 L2.09864406,0.0228787371 C0.837792887,0.854761223 0.00451383643,2.28285862 0.00451383643,3.90733185 L0.00451383643,3.90733185 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0252195081,4.98495352 C0.0252195081,7.72120074 2.24938135,9.94731844 4.98319259,9.94731844 L4.98319259,9.94731844 C7.71708666,9.94731844 9.9412485,7.72120074 9.9412485,4.98495352 L9.9412485,4.98495352 C9.9412485,2.24874775 7.71708666,0.0226715021 4.98319259,0.0226715021 L4.98319259,0.0226715021 C2.24938135,0.0226715021 0.0252195081,2.24874775 0.0252195081,4.98495352 L0.0252195081,4.98495352 Z M0.646389658,4.98495352 C0.646389658,2.59155579 2.59189457,0.644376314 4.98319259,0.644376314 L4.98319259,0.644376314 C7.37457344,0.644376314 9.32003693,2.59163868 9.32003693,4.98495352 L9.32003693,4.98495352 C9.32003693,7.37835126 7.37457344,9.32557218 4.98319259,9.32557218 L4.98319259,9.32557218 C2.59189457,9.32557218 0.646389658,7.37843416 0.646389658,4.98495352 L0.646389658,4.98495352 Z",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.84048574,0.0717032883 L0.18063628,1.06854478 C0.0870880551,1.12462256 0.0298989899,1.22587755 0.0298989899,1.33504891 L0.0298989899,1.33504891 C0.0298989899,1.44426173 0.0870880551,1.54543382 0.18063628,1.60159449 L0.18063628,1.60159449 L1.84048574,2.59831164 C1.89051065,2.62840216 1.94562914,2.64265992 2.00000224,2.64265992 L2.00000224,2.64265992 C2.10551834,2.64265992 2.20838412,2.58882028 2.26656706,2.49166855 L2.26656706,2.49166855 C2.35485604,2.34444885 2.30715017,2.15354402 2.16005708,2.06522049 L2.16005708,2.06522049 L1.46186183,1.64590132 L3.66010017,1.64590132 C4.40405495,1.64590132 5.00932315,2.25169049 5.00932315,2.99628562 L5.00932315,2.99628562 C5.00932315,3.7408393 4.40405495,4.34662847 3.66010017,4.34662847 L3.66010017,4.34662847 L1.33638546,4.34662847 C1.16485968,4.34662847 1.0258418,4.48576601 1.0258418,4.65748088 L1.0258418,4.65748088 C1.0258418,4.82919575 1.16485968,4.96833328 1.33638546,4.96833328 L1.33638546,4.96833328 L3.66010017,4.96833328 C4.74656817,4.96833328 5.63053471,4.08364733 5.63053471,2.99628562 L5.63053471,2.99628562 C5.63045189,1.90879956 4.74656817,1.02415506 3.66010017,1.02415506 L3.66010017,1.02415506 L1.46177901,1.02415506 L2.16005708,0.604794441 C2.30719158,0.516470911 2.35489745,0.32552464 2.26656706,0.178346387 L2.26656706,0.178346387 C2.20834271,0.0811532015 2.10547693,0.0273135647 2.00000224,0.0273135647 L2.00000224,0.0273135647 C1.94558773,0.0273135647 1.89051065,0.0416127754 1.84048574,0.0717032883 L1.84048574,0.0717032883 Z",
    id: "path-17"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "snoo_rental",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hbi_rental_acc_overview_snoo_picked_up",
    transform: "translate(-690.000000, -267.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-46",
    transform: "translate(191.000000, 136.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(500.000000, 132.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-42"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#8E745E",
    points: "55.5342118 23.9456511 46.7667679 28.8698511 47.218661 5.23866684 55.9368428 2.87745632"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#A38970",
    points: "46.7726524 28.8478874 0.155647059 23.2983558 0.155647059 2.04105053 47.2245455 5.21670316"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#BC9E83",
    points: "47.218646 5.23866684 0.149747594 2.06301421 12.6748813 0.152524737 55.9369775 2.87745632"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 0.022437)",
    stroke: "#4D596B",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.14973262,2.04054684 L39.9545027,4.72609947",
    id: "Stroke-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6748513,0.130118421 L55.9369476,2.85505",
    id: "Stroke-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.14973262,23.2977758 L46.766738,28.8473074",
    id: "Stroke-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.14973262,2.04054684 L0.14973262,23.2976995",
    id: "Stroke-10"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.218646,5.23866684 L46.844015,24.8359511",
    id: "Stroke-13",
    stroke: "#4D596B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(0.149733, 0.022437)",
    stroke: "#4D596B",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7871701,2.85505 L55.384539,23.9232447",
    id: "Stroke-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,2.04054684 L12.5251337,0.130057368",
    id: "Stroke-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0689134,5.21623 L55.7872449,2.85501947",
    id: "Stroke-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6170802,28.8473684 L55.3845241,23.9231684",
    id: "Stroke-20"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.2723679,4.96231211 L47.2185711,5.23872789",
    id: "Stroke-23",
    stroke: "#4D596B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8168235,26.2576226 L46.7668128,28.8697595",
    id: "Stroke-24",
    stroke: "#4D596B",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-41",
    transform: "translate(7.935829, 9.943489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.58196364,0.392003684 C2.8267123,0.320724737 2.18450909,0.478851053 1.6580492,0.866687895 C1.13173904,1.25330368 0.848295187,1.82399316 0.809214973,2.57906158 L0.80786738,2.60775632 C0.789450267,2.96140368 0.83362139,3.28009842 0.941279144,3.56368789 C1.04908663,3.84727737 1.21334332,4.08553526 1.43389947,4.27876684 C1.65445561,4.47306684 1.87066952,4.63027737 2.08089412,4.75131421 C2.29246631,4.87113 2.5476107,4.99354053 2.84917219,5.11915632 C2.91101176,5.14403526 2.99546096,5.17791947 3.10162139,5.22096158 C3.20882995,5.26522474 3.29208128,5.29895632 3.35392086,5.32398789 C3.41695829,5.35039316 3.4913754,5.38336158 3.58076578,5.42472474 C3.66865882,5.46715632 3.7364877,5.50210895 3.78530053,5.53004053 C3.83276578,5.55919316 3.8902631,5.59323 3.95644492,5.63383 C4.02142888,5.67275105 4.07353583,5.71182474 4.11291551,5.74830368 C4.15214545,5.78615632 4.18748235,5.82507737 4.22266952,5.86659316 C4.25650909,5.90948263 4.27881925,5.95389842 4.29034866,6.00304579 C4.30082995,6.05173526 4.30472299,6.09996684 4.30217754,6.14896158 L4.30068021,6.17750368 C4.28091551,6.55984579 3.98384599,6.72316158 3.40677647,6.66882474 C2.78628449,6.61021421 2.14542888,6.31868789 1.48435936,5.79561947 C1.3716107,5.70846684 1.2376,5.65748789 1.08502246,5.64314053 C0.860722995,5.62207737 0.663974332,5.68816684 0.49762139,5.83927211 C0.33246631,5.99175105 0.242477005,6.18849316 0.23019893,6.42659842 C0.213279144,6.75170368 0.331418182,7.01163526 0.584017112,7.20914053 C1.40020963,7.87140895 2.2942631,8.24840895 3.26632727,8.33998789 C4.09464813,8.41813526 4.77353583,8.27298263 5.3040385,7.90605632 C5.83454118,7.53913 6.12053048,6.94401947 6.16290481,6.12225105 L6.16455187,6.09355632 C6.18177112,5.75883526 6.1367016,5.45784579 6.02829519,5.18799316 C5.91988877,4.91783526 5.7515893,4.68461421 5.52219893,4.48527737 C5.29280856,4.28594053 5.07434866,4.12583 4.86786738,4.00525105 C4.6613861,3.88604579 4.40414545,3.75356158 4.09464813,3.60825632 C3.67090481,3.40556158 3.44076578,3.29765105 3.40527914,3.28483 C2.90277647,3.03497211 2.65766417,2.79183 2.67009198,2.55235105 L2.67143957,2.52365632 C2.6793754,2.37133 2.75139679,2.25105632 2.88735401,2.16268263 C3.02211337,2.07415632 3.2118246,2.04286684 3.45543957,2.06576158 C3.8696,2.10498789 4.38318289,2.31607737 4.99723636,2.70070895 C5.11956791,2.77931421 5.24339679,2.82388263 5.36917219,2.83563526 C5.60380321,2.85776684 5.80429519,2.79320368 5.97064813,2.64087737 C6.13580321,2.48824579 6.22579251,2.29303 6.23807059,2.05355105 C6.2573861,1.68204579 6.10989947,1.39341947 5.7942631,1.19133526 C5.07599572,0.729777368 4.33856257,0.463282632 3.58196364,0.392003684",
    id: "Fill-26",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-31"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2080107,1.08272263 C10.3976578,1.00625421 9.66860963,1.35028579 9.02341176,2.11527526 L9.02775401,2.02964895 C9.04362567,1.72347 8.95827807,1.45697526 8.77036364,1.22741737 C8.58364706,0.999233158 8.34557219,0.870106842 8.05823529,0.842938421 C7.76985027,0.81577 7.52069519,0.898954211 7.31226738,1.08974368 C7.10279144,1.28190684 6.99064171,1.52978053 6.97491979,1.83595947 L6.68129412,7.51095421 C6.66557219,7.81575947 6.75091979,8.08362789 6.93883422,8.31181211 C7.12540107,8.54137 7.36362567,8.66912263 7.65216043,8.69644368 C7.93934759,8.72345947 8.18835294,8.64164895 8.39678075,8.44948579 C8.60640642,8.25869632 8.71855615,8.00944895 8.73427807,7.70464368 L8.90407487,4.42291211 C8.93027807,3.91663316 9.0644385,3.53978579 9.30895187,3.29481211 C9.55241711,3.04846474 9.8708984,2.94452263 10.2684385,2.98207 C10.6632834,3.01931211 10.9628984,3.18155947 11.1657861,3.47003316 C11.3673262,3.75698053 11.4562674,4.15504368 11.4300642,4.66117 L11.2604171,7.94290158 C11.2446952,8.24770684 11.3313904,8.51572789 11.5243957,8.74437 C11.7160535,8.97453842 11.950385,9.10183316 12.2299358,9.12823842 C12.5082888,9.15449105 12.7547487,9.07252789 12.9682674,8.88067 C13.182984,8.69049105 13.2976791,8.44139632 13.3134011,8.13674368 L13.5186845,4.16649105 C13.5646524,3.27802263 13.3840749,2.56095947 12.9781497,2.01255421 C12.5720749,1.46567526 11.9812299,1.15568053 11.2080107,1.08272263",
    id: "Fill-29",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-34"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1440449,1.73706947 C17.0271893,1.63175368 16.077585,1.92908 15.2953818,2.62767474 C14.5131786,3.32642211 14.0927294,4.23015368 14.0353818,5.33917474 L14.0338845,5.36756421 C13.9760877,6.48452211 14.302954,7.46563789 15.0143337,8.31075895 C15.7269112,9.15588 16.6404299,9.63056421 17.7574353,9.73572737 C18.8742909,9.84119579 19.8238952,9.54524316 20.6060984,8.84512211 C21.3883016,8.14652737 21.8087508,7.24264316 21.8659487,6.13514842 L21.867446,6.10660632 C21.9253925,4.98827474 21.5985262,4.00715895 20.8859487,3.16203789 C20.1744193,2.31829053 19.2609005,1.84238526 18.1440449,1.73706947 M17.8276599,7.85576421 C17.2607722,7.80219053 16.8159166,7.55935368 16.4942909,7.12557474 C16.1726652,6.69194842 16.0278738,6.17925895 16.0584193,5.58735368 L16.0599166,5.55881158 C16.0900128,4.97652211 16.2940984,4.49390105 16.6708257,4.11110105 C17.0475529,3.72967474 17.5160663,3.56468 18.0738203,3.61718526 C18.6405583,3.67075895 19.0855636,3.91374842 19.4071893,4.34737474 C19.7286652,4.78100105 19.8736064,5.29369053 19.8429112,5.88681684 L19.8414139,5.91551158 C19.8113176,6.49780105 19.6072321,6.98042211 19.2306545,7.36184842 C18.8539273,7.74464842 18.3854139,7.90842211 17.8276599,7.85576421",
    id: "Fill-32",
    fill: "#FFFFFF",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-37"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3828428,2.51431526 C25.2673348,2.40915211 24.3177305,2.70647842 23.5353775,3.40507316 C22.7519765,4.10382053 22.3328749,5.00755211 22.2753775,6.11642053 L22.2740299,6.14511526 C22.2162332,7.26207316 22.5429497,8.24318895 23.2543294,9.08815737 C23.9657091,9.93327842 24.8807251,10.40781 25.9975807,10.5132784 C27.1130888,10.6184416 28.062693,10.3224889 28.8448963,9.62252053 C29.6284471,8.92392579 30.0475487,8.02004158 30.1047465,6.91254684 L30.1062439,6.88385211 C30.1641904,5.76552053 29.8373241,4.78455737 29.1259444,3.93928368 C28.414415,3.09568895 27.4996984,2.61963105 26.3828428,2.51431526 M26.0664578,8.63285737 C25.4997198,8.57943632 25.056062,8.33659947 24.7344364,7.90297316 C24.4128107,7.46919421 24.2680193,6.95650474 24.2985647,6.36475211 L24.300062,6.33621 C24.3301583,5.75376789 24.533046,5.27114684 24.9096235,4.88834684 C25.2876984,4.50692053 25.7548642,4.34192579 26.3139658,4.39458368 C26.8807037,4.44800474 27.3243615,4.69084158 27.6459872,5.12462053 C27.9676128,5.55824684 28.1124043,6.07093632 28.0818588,6.66421526 L28.0802118,6.69275737 C28.0501155,7.27519947 27.8473775,7.75782053 27.4708,8.13924684 C27.0927251,8.52189421 26.6254096,8.68566789 26.0664578,8.63285737",
    id: "Fill-35",
    fill: "#FFFFFF",
    mask: "url(#mask-8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-40"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5880484,2.99960315 C30.3125848,2.97505819 30.0776694,3.1779773 30.0624638,3.45326171 C30.0474786,3.72875773 30.2579328,3.9710334 30.5333964,3.99557836 C30.80886,4.02012332 31.0457587,3.81741581 31.0609643,3.5419198 C31.0759495,3.26663538 30.863512,3.02414811 30.5880484,2.99960315 M30.5384649,3.90311158 C30.3174329,3.88343329 30.1484085,3.68643883 30.1607493,3.46214868 C30.1728697,3.23764694 30.3621682,3.07239165 30.5829798,3.09206994 C30.8037914,3.11174823 30.9730363,3.30874269 30.9606955,3.53303283 C30.9485751,3.75774617 30.7592765,3.92278986 30.5384649,3.90311158 M30.6369707,3.2162759 L30.374509,3.19300051 L30.3445386,3.74187658 L30.4461295,3.75097515 L30.4567073,3.56032852 L30.5926762,3.572601 L30.6803838,3.77171141 L30.7991637,3.78229113 L30.6933856,3.56815752 C30.7625821,3.5497488 30.8115044,3.49134872 30.8156915,3.41221239 C30.8218619,3.30281804 30.7537673,3.22664403 30.6369707,3.2162759 M30.4619962,3.46426463 L30.4712518,3.29625861 L30.6334448,3.31064704 C30.6863338,3.31551371 30.7171857,3.34090505 30.7136598,3.40311382 C30.7105746,3.4653226 30.6676023,3.48246175 30.6244096,3.47865305 L30.4619962,3.46426463",
    id: "Fill-38",
    fill: "#FFFFFF",
    mask: "url(#mask-10)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group-51",
    transform: "translate(42.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(0.686085, 0.648726)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#F38387",
    mask: "url(#mask-12)",
    points: "-0.202915582 9.51224941 9.50638798 9.51224941 9.50638798 -0.20541127 -0.202915582 -0.20541127"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(0.686085, 1.394772)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-18"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    fill: "#E5636D",
    mask: "url(#mask-14)",
    points: "-0.202501469 8.7659964 8.7401953 8.7659964 8.7401953 -0.1843562 -0.202501469 -0.1843562"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(0.354794, 0.317150)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-21"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-20",
    fill: "#4D596B",
    mask: "url(#mask-16)",
    points: "-0.181837209 10.1545119 10.1483052 10.1545119 10.1483052 -0.184563435 -0.181837209 -0.184563435"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(2.673830, 2.638181)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-24"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    fill: "#4D596B",
    mask: "url(#mask-18)",
    points: "-0.177199138 5.17556822 5.83755002 5.17556822 5.83755002 -0.179921373 -0.177199138 -0.179921373"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnooBoxPickedUpActive);
export default __webpack_public_path__ + "static/media/snoo-box-picked-up-active.599ec81e6ab8bef7cca2db9c562d77bf.svg";
export { ForwardRef as ReactComponent };